import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {initReactI18next} from 'react-i18next';
import i18next from 'i18next';
import common_de from "./translations/de/common.json";
import common_en from "./translations/en/common.json";
import {Redirect, Route, Switch} from "react-router";
import {BrowserRouter} from "react-router-dom";
import LanguageDetector from 'i18next-browser-languagedetector';
import {Provider} from "react-redux";
import configureStore from "./store";
import dotenv from 'dotenv';

dotenv.config();

i18next
    .use(LanguageDetector) // detect user language
    .use(initReactI18next) // pass the i18n instance to react-i18next
    .init({
        interpolation: {escapeValue: false}, // React already does escaping
        fallbackLng: 'en', // language to use
        resources: {
            en: {
                common: common_en // 'common' is our custom namespace
            },
            de: {
                common: common_de
            },
        },
    });

const store = configureStore();

/*
// TODO implement, only if we need this
axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (error.status === 401) {
        console.log('Received unauthorized response, clear saved login data.')
        localStorage.clear();
        store.dispatch({type: USER_LOGOUT});
    }
    return Promise.reject(error);
});
*/

ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter basename={process.env.REACT_APP_ROUTER_BASE || ''}>
            <Switch>
                <Route path="/app" component={() => (
                    <App/>
                )}/>
                <Redirect from="/" to="/app"/>
            </Switch>
        </BrowserRouter>
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
